// Round 95p·2 (Feb 2026) — Single source of truth for password rules.
// Kept in sync with backend `_validate_password_strength` in server.py.
// Rules: 8+ chars, ≥1 uppercase, ≥1 lowercase, ≥1 digit.

export function validatePassword(pw) {
  const password = pw || '';
  const rules = [
    { key: 'length', label: 'At least 8 characters',       ok: password.length >= 8 },
    { key: 'upper',  label: '1 uppercase letter (A–Z)',    ok: /[A-Z]/.test(password) },
    { key: 'lower',  label: '1 lowercase letter (a–z)',    ok: /[a-z]/.test(password) },
    { key: 'digit',  label: '1 number (0–9)',              ok: /[0-9]/.test(password) },
  ];
  return { rules, valid: rules.every(r => r.ok) };
}
